import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { isUnlimitedSpeakingValue, normalizeUnlimitedSpeakingValue } from './speaking-number-policy';
import { Result } from '@digibricks/core';
export var SpeakingMinAnswerDuration = /*#__PURE__*/function () {
  function SpeakingMinAnswerDuration() {
    _classCallCheck(this, SpeakingMinAnswerDuration);
  }

  _createClass(SpeakingMinAnswerDuration, null, [{
    key: "isUnlimited",
    value: function isUnlimited(value) {
      return isUnlimitedSpeakingValue(value);
    }
  }, {
    key: "normalize",
    value: function normalize(value) {
      return normalizeUnlimitedSpeakingValue(value);
    }
  }, {
    key: "create",
    value: function create(value) {
      var normalizedValue = this.normalize(value);

      if (normalizedValue === this.Unlimited) {
        return Result.ok(normalizedValue);
      }

      if (!Number.isFinite(normalizedValue) || normalizedValue < 1) {
        return Result.fail('Speaking minimum answer duration must be positive or unlimited');
      }

      return Result.ok(normalizedValue);
    }
  }]);

  return SpeakingMinAnswerDuration;
}();

_defineProperty(SpeakingMinAnswerDuration, "Unlimited", -1);

_defineProperty(SpeakingMinAnswerDuration, "Default", 5);